import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData, FsCatalog } from '../../types'
import { CmsConverterService, defaultFSCatalog } from '../../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class HandBookContainerConverter extends CmsConverterService<MacsHandBookContainerData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    return {
      content: formData.st_content ?? defaultFSCatalog,
    }
  }
}

export const MACS_HANDBOOK_CONTAINER_CONVERTER_TOKEN =
  new InjectionToken<Converter<CmsComponent, MacsHandBookContainerData>>('HandBookContainerConverter')

export interface MacsHandBookContainerData extends ConvertedComponentData {
  content: FsCatalog;
}

export interface StickyNavDTO {
  headline: string;
  uuid?: string;
  previewId: string;
  levelId?: number;
  children?: StickyNavDTO[];
}
